import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  RatingRulesFindByPageParams,
  RatingRulesListByTypeParams,
  RatingRulesSaveParams,
  RatingRulesUpdateParams,
  RatingRulesDeleteParams
} from '@/typings/api/overseasSales'

/**
 * ************************************** 业务配置 评级规则、成交额档次 **************************************
 */
// 分页查询业务配置
export function ratingRulesFindByPage(data: RatingRulesFindByPageParams) {
  return request.post<AxiosResult>('/base/api/bizConfig/findByPage', data)
}
// 查询业务配置列表
export function ratingRulesListByType(data: RatingRulesListByTypeParams) {
  return request.post<AxiosResult>('/base/api/bizConfig/listByType', data)
}
// 保存业务配置
export function ratingRulesSave(data: RatingRulesSaveParams) {
  return request.post<AxiosResult>('/base/api/bizConfig/save', data)
}
// 更新业务配置
export function ratingRulesUpdate(data: RatingRulesUpdateParams) {
  return request.post<AxiosResult>('/base/api/bizConfig/update', data)
}
// 删除业务配置
export function ratingRulesDelete(data: RatingRulesDeleteParams) {
  return request.post<AxiosResult>('/base/api/bizConfig/delete', data)
}
